import React, {useContext} from "react"
import {NavLink} from "react-router-dom"

import {ShoppingCartContext} from "../../context/ShoppingCartContext"
import {useTranslation} from "react-i18next"

const ShoppingCart = () => {
  const {t} = useTranslation()
  const {shoppingCart} = useContext(ShoppingCartContext)
  let shoppingCartItemCount = 0
  if (shoppingCart.product_in_carts) {
    shoppingCartItemCount = shoppingCart.product_in_carts.length
  }

  return (
    <div className={`visible`}>
      <NavLink to={"/shopping_cart"}>
        <div style={{display: "flex", justifyContent: "space-between"}}>
          {t("navigationItems.shoppingCart")}{" "}
          {shoppingCartItemCount > 0 && (
            <div className="item-count">{shoppingCartItemCount}</div>
          )}
        </div>
      </NavLink>
    </div>
  )
}
export default ShoppingCart



// WEBPACK FOOTER //
// ./src/components/navigations/ShoppingCart.js